<div class="my-2 mx-1">
  <div class="flex flex-wrap justify-content-between align-items-start mb-2">
    <button
      type="button"
      pButton
      icon="fa fa-plus"
      label="{{ 'BTN_AGREGAR' | translate }}"
      (click)="onCreateOrEdit()"
      [disabled]="showForm"
      [loading]="!showForm && (isLoading || saving)"
      *ngIf="!isDetail">
    </button>

    <form
      @slideCollapse
      *ngIf="showForm"
      [formGroup]="form"
      novalidate
      class="form-panel mt-3 mb-2 py-2 w-full"
      [ngClass]="isNewRecord ? 'create' : 'edit'">
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12 pb-0">
          <span class="text-sm font-semibold" style="color: #5E5E5E;">
            {{( isNewRecord ? 'LBL_AGREGAR' : 'LBL_EDITAR') | translate | uppercase}} {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA' | translate | uppercase }}
          </span>
        </div>
        <div class="div-form col-12 md:col">
          <label for="idCanal">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_CANAL' | translate }}</label>
          <p-dropdown
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="channels"
            id="idCanal"
            name="idCanal"
            formControlName="idCanal">
          </p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCanal.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_CANAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && form.errors?.uniqueCombination">
            {{ 'PRODUCTO_PASARELA_TARIFAS.MSG_COMBINACION_DUPLICADA' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="idMedioPago">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MEDIO_PAGO' | translate }}</label>
          <p-dropdown
            placeholder="{{ 'LBL_SELECCIONAR' | translate }}"
            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
            optionValue="value"
            optionLabel="label"
            [filter]="true"
            [options]="paymentMethods"
            id="idMedioPago"
            name="idMedioPago"
            formControlName="idMedioPago">
          </p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idMedioPago.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MEDIO_PAGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && form.errors?.uniqueCombination">
            {{ 'PRODUCTO_PASARELA_TARIFAS.MSG_COMBINACION_DUPLICADA' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="tarifaTrxVentaPorcentaje">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_VENTA' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="tarifaTrxVentaPorcentaje"
            name="tarifaTrxVentaPorcentaje"
            pInputText
            formControlName="tarifaTrxVentaPorcentaje"
            number-format-reactive
            [suffix]="percentageSymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tarifaTrxVentaPorcentaje.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_VENTA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="tarifaTrxIndividual">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_INDIVIDUAL' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="tarifaTrxIndividual"
            name="tarifaTrxIndividual"
            pInputText
            formControlName="tarifaTrxIndividual"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tarifaTrxIndividual.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_TARIFA_INDIVIDUAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="montoMinimoTrx">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MINIMO' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="montoMinimoTrx"
            name="montoMinimoTrx"
            pInputText
            formControlName="montoMinimoTrx"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimoTrx.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>

      <div class="grid form-group">
        <div class="div-form col-12 md:col">
          <label for="montoMaximoTrx">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="montoMaximoTrx"
            name="montoMaximoTrx"
            pInputText
            formControlName="montoMaximoTrx"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximoTrx.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="montoMaximoMes">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO_MES' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="montoMaximoMes"
            name="montoMaximoMes"
            pInputText
            formControlName="montoMaximoMes"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximoMes.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_MONTO_MAXIMO_MES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="limiteTrxDiario">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_DIARIO' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="limiteTrxDiario"
            name="limiteTrxDiario"
            pInputText
            formControlName="limiteTrxDiario"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.limiteTrxDiario.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_DIARIO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col">
          <label for="limiteTrxMes">* {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_MES' | translate }}</label>
          <input
            type="text"
            autocomplete="off"
            placeholder="{{ 'LBL_INGRESAR' | translate }}"
            id="limiteTrxMes"
            name="limiteTrxMes"
            pInputText
            formControlName="limiteTrxMes"
            number-format-reactive
            [prefix]="moneySymbol"
            [maxIntegerDigits]="7"
            [maxDecimalDigits]="6">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.limiteTrxMes.invalid">
            {{ 'PRODUCTO_PASARELA_TARIFAS.LBL_LIMITE_MES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>

        <div class="div-form col-12 md:col mt-4">
          <p-checkbox
            label="{{ 'PRODUCTO_PASARELA.LBL_APLICA_TASA_PREFERENCIAL' | translate }}"
            [binary]="true"
            formControlName="indicadorAplicaTarifaEspecial">
          </p-checkbox>
        </div>
      </div>

      <div class="grid form-footer-buttons border-none">
        <div class="form-group col-12 gap-3">
          <button
            type="button"
            pButton
            class="btn-primary-outline shadow-none"
            label="{{ 'BTN_CANCELAR' | translate }}"
            (click)="onCancel()"
            [loading]="saving || isLoading">
          </button>
          <button
            type="submit"
            pButton
            class="shadow-none"
            icon="fa fa-check-circle-o"
            label="{{( isNewRecord ? 'BTN_GUARDAR' : 'BTN_ACTUALIZAR')  | translate }}"
            (click)="onSubmit()"
            [loading]="saving || isLoading">
          </button>
        </div>
      </div>
    </form>

    <div class="col-12 md:col-3 lg:col-3 md:ml-auto">
      <span class="new-input-icon">
        <i class="pi pi-search"></i>
        <input
          type="text"
          pInputText
          class="new-input"
          placeholder="{{ 'LBL_BUSCAR' | translate }}"
          (input)="dt.filterGlobal($any($event.target).value, 'contains')">
      </span>
    </div>
  </div>

  <p-table
    #dt
    [columns]="cols"
    [value]="records"
    [loading]="isLoading"
    [paginator]="true"
    [rows]="rows"
    selectionMode="single"
    dataKey="idProductoPasarelaTarifa"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm table-premium">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.nombreCanal }}</td>
          <td>{{ row.nombreMedioPago }}</td>
          <td>{{ row.tarifaTrxVentaPorcentaje | numberFormat:6:'':percentageSymbol }}</td>
          <td>{{ row.tarifaTrxIndividual | numberFormat:6:moneySymbol }}</td>
          <td>{{ row.montoMinimoTrx | numberFormat:6:moneySymbol }}</td>
          <td>{{ row.montoMaximoTrx | numberFormat:6:moneySymbol }}</td>
          <td>{{ row.montoMaximoMes | numberFormat:6:moneySymbol }}</td>
          <td>{{ row.limiteTrxDiario | numberFormat:6:moneySymbol }}</td>
          <td>{{ row.limiteTrxMes | numberFormat:6:moneySymbol }}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorAplicaTarifaEspecial" [binary]="true" [disabled]="true"></p-checkbox>
          </td>
          <td *ngIf="!isDetail">
            <p-button
              icon="fa fa-pencil"
              type="button"
              styleClass="btn-action-premium"
              data-toggle="tooltip"
              [title]="'BTN_EDITAR' | translate"
              [loading]="saving"
              (onClick)="onCreateOrEdit(row)">
            </p-button>
            <p-button
              icon="fa fa-trash"
              type="button"
              styleClass="btn-action-premium ml-2"
              data-toggle="tooltip"
              [title]="'BTN_ELIMINAR' | translate"
              [loading]="saving"
              (onClick)="onDelete(row)">
            </p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns?.length || 1" class="text-center">
            {{ 'MSG_NOHAYREGISTROS' | translate }}
          </td>
        </tr>
      </ng-template>
  </p-table>
</div>

<p-confirmDialog #cd [key]="cdKey">
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-outline" icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton class="btn-primary-full" icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
